module.exports = __webpack_public_path__ + "img/Skirt-Front-B6-Da-Fc-Gd-Hc-Ia-outside.6f61c399.png";